import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpUtilsService, QueryParamsModel} from '../_base/crud';
import {LatestChangeDetailModel, LatestChangesModel} from '../models/latest_changes.model';
import {environment} from '../../../environments/environment';
import { ConversationsService } from './conversations.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AppState } from '../reducers';
import { Store } from '@ngrx/store';
import { LoadAllLatestChangesAction } from '../actions/all_latest_changes.actions';
import { LoadProjectsAction } from '../actions/project.actions';
import { UserModel } from '../auth';

const API_LATEST_CHANGES_URL = `${environment.pathToAPI}/api/v1/latest_changes`;

@Injectable()
export class LatestChangesService {
    constructor(
        private router: Router,
        private store: Store<AppState>,
        private http: HttpClient,
        private httpUtils: HttpUtilsService,
        private conversationsService: ConversationsService,
        private translateService: TranslateService,
        ) {
    }

    findAll(): Observable<LatestChangesModel[]> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.get<LatestChangesModel[]>(API_LATEST_CHANGES_URL, {headers: httpHeaders});
    }

    findFor(projectId: number, token: string | null = null): Observable<LatestChangesModel[]> {
        const httpHeaders = this.httpUtils.getHTTPHeaders(token);
        return this.http.get<LatestChangesModel[]>(API_LATEST_CHANGES_URL + `/${projectId}`, {headers: httpHeaders});
    }

    formatTitle(data: LatestChangeDetailModel): string {
        switch (data.operation) {
            case 'addProject':
                return this.translateService.instant('LATEST_CHANGES.ADD_PROJECT', {
                    fullname: data.fullname,
                    subject: data.subject,
                    projectName: data.projectName
                });
            case 'updateProject':
                return this.translateService.instant('LATEST_CHANGES.UPDATE_PROJECT', {
                    fullname: data.fullname || 'クライアント',
                    subject: data.subject,
                    projectName: ''
                });
            case 'deleteProject':
                return this.translateService.instant('LATEST_CHANGES.DELETE_PROJECT', {
                    fullname: data.fullname,
                    subject: data.subject,
                    projectName: data.projectName
                });
            case 'addConversation':
                return this.translateService.instant('LATEST_CHANGES.ADD_CONVERSATION', {
                    fullname: data.fullname,
                    subject: data.subject,
                    projectName: data.projectName
                });
            case 'updateConversation':
                return this.translateService.instant('LATEST_CHANGES.UPDATE_CONVERSATION', {
                    fullname: data.fullname,
                    subject: data.subject,
                    projectName: data.projectName
                });
            case 'deleteConversation':
                return this.translateService.instant('LATEST_CHANGES.DELETE_CONVERSATION', {
                    fullname: data.fullname,
                    subject: data.subject,
                    projectName: data.projectName
                });
        }
    }

    goTo(data: LatestChangeDetailModel, currentUser: UserModel) {
        if (data.operation === 'addProject' || data.operation === 'updateProject' || data.operation === 'deleteProject') {
            this.router.navigateByUrl(`/project-management/projects/${data.projectId}`);
        } else if (data.operation === 'addConversation' || data.operation === 'updateConversation' || data.operation === 'deleteConversation') {
            this.conversationsService.readConversation(data.conversationId, currentUser.id).subscribe(() => {
                this.store.dispatch(new LoadAllLatestChangesAction());
                const queryParams = new QueryParamsModel({userId: currentUser.id}, 'desc', 'modifiedAt', 0, 25);
                this.store.dispatch(new LoadProjectsAction({page: queryParams}));
            });
            this.router.navigateByUrl(`/project-management/chat-groups/${data.projectId}/${data.conversationId}`);
        } else {
            console.error("unknown operation:" + data.operation);
        }
    }
}
